module.exports = function() {
  return new Worker(__webpack_public_path__ + "a1a29221d9428fb55240.worker.js");
};